import styles from './index.less';
import { Form, Picker, Input, Uploader, Toast, Button } from 'react-vant';
import {
  leaveMessageTypeList,
  leaveMessageTypeMap,
} from '@/pages/ServicesMore/config';
import { useSafeState } from 'ahooks';
import { queryCommonUploads } from '@/service';
import StickyBtnStyle from '@/components/FloatButton/index.less';
import { queryCreateMessage } from '@/pages/ServicesMore/service';
import { useModel, useNavigate } from '@umijs/max';

const MessageForm = () => {
  const [form] = Form.useForm();
  const [urlPath, setUrlPath] = useSafeState<string>();
  const { defaultCustomerInformation } = useModel(
    'useDefaultCustomer',
    (model) => ({
      defaultCustomerInformation: model.defaultCustomerInformation,
    }),
  );

  const navigate = useNavigate();

  const jumpToDetail = (id: string) => {
    navigate('/messageDetail', {
      state: {
        id: id,
      },
    });
  };

  const onFinish = async (values: any) => {
    const res = await queryCreateMessage({
      ...values,
      customerId: defaultCustomerInformation?.sequenceNbr,
      customerName: defaultCustomerInformation?.customerName,
      roomCode: defaultCustomerInformation?.roomCode,
      roomId: defaultCustomerInformation?.roomId,
      communityId: defaultCustomerInformation?.communityId,
      communityName: defaultCustomerInformation?.communityName,
      phone: defaultCustomerInformation?.phone,
      status: 0,
      urlPath: urlPath || '',
    });
    if (res?.code === 200) {
      jumpToDetail(res?.data?.sequenceNbr);
    }
  };

  const uploadFile = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append('files', file);
      const res = await queryCommonUploads(formData);
      if (res?.code === 200) {
        setUrlPath((prevState) => {
          if (prevState !== undefined) {
            return prevState + ',' + res?.fileNames;
          } else {
            return res?.fileNames;
          }
        });
        return { url: `${res?.fileNames}` };
      }
    } catch (error) {
      Toast.fail('上传失败');
      return { url: '' };
    }
  };

  return (
    <div className={styles.container}>
      <Form
        className={styles.form}
        form={form}
        onFinish={onFinish}
        footer={
          <div className={StickyBtnStyle.container}>
            <Button
              round
              // style={{ margin: '16px  0' }}
              nativeType="submit"
              type="primary"
              block
            >
              提交
            </Button>
          </div>
        }
      >
        <Form.Item
          label={'留言类型'}
          isLink
          name={'type'}
          rules={[{ required: true, message: '请选择留言类型' }]}
          trigger={'onConfirm'}
          onClick={(_, action) => {
            action?.current?.open();
          }}
        >
          <Picker popup columns={leaveMessageTypeList}>
            {(value) =>
              typeof value === 'string'
                ? leaveMessageTypeMap[value]
                : value || '请选择留言类型'
            }
          </Picker>
        </Form.Item>
        <Form.Item
          rules={[{ required: true, message: '请输入留言描述' }]}
          label={'留言描述'}
          name={'content'}
        >
          <Input.TextArea
            placeholder={'请输入留言描述'}
            showWordLimit={({ currentCount }) => (
              <span>已经输入{currentCount}个字啦 ✍️</span>
            )}
          />
        </Form.Item>
        <Form.Item label={'添加图片'} name={'urlPath'}>
          <Uploader
            maxCount={3}
            maxSize={5 * 1024 * 1024}
            onOversize={() => Toast.info('文件大小不能超过5M')}
            // onChange={handleFileChange}
            accept={'image/*'}
            upload={uploadFile as any}
            multiple
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default MessageForm;
